import DocumentSettingsFormData from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/FormData/DocumentSettingsFormData';
import * as React from 'react';
import { useSelector } from '@verclam/synapse';

/**
 * A function building the settings of a newly added document from the preset of its type (matched on
 * the type's key, with the generic preset as fallback). Reads the catalogue and the types from the
 * store: the editor only mounts once they are loaded, or once the catalogue has failed — in which
 * case documents start neutral.
 */
function useDocumentSettingsFactory(): (documentTypeId: number) => DocumentSettingsFormData {
	const catalog = useSelector((state) => state.organizationWorkflowsStore.catalog);
	const documentTypes = useSelector((state) => state.documentTypesStore.documentTypes);

	return React.useCallback(
		(documentTypeId: number) => {
			const documentTypeKey = documentTypes?.findById(documentTypeId)?.key ?? null;

			return DocumentSettingsFormData.createForDocumentType(
				documentTypeId,
				catalog?.findForDocumentType(documentTypeKey) ?? null,
			);
		},
		[catalog, documentTypes],
	);
}

export default useDocumentSettingsFactory;
